/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const ifaApprovalGetResponseSchema = z.object({
  data: z.object({
    ifa_details: z
      .object({
        company_name: z.string(),
        email: z.string(),
        name: z.string(),
      })
      .optional(),
    users: z
      .array(
        z.object({
          email: z.string(),
          name: z.string(),
        })
      )
      .optional(),
  }),
  response: z.object({
    date: z.string(),
    messages: z.array(z.string()),
    status: z.number().int(),
    type: z.string(),
  }),
});
